import { render, staticRenderFns } from "./ExtendedDatePicker.vue?vue&type=template&id=2e16daef&scoped=true&"
import script from "./ExtendedDatePicker.vue?vue&type=script&lang=js&"
export * from "./ExtendedDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedDatePicker.vue?vue&type=style&index=0&id=2e16daef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16daef",
  null
  
)

export default component.exports